import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "keyboard_arrow_sort",
  "use": "keyboard_arrow_sort-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"keyboard_arrow_sort\"><path d=\"M328 344l196 196 196-196 60 60-256 256-256-256 60-60z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/keyboard_arrow_sort.svg
// module id = uSGj
// module chunks = 1